import { featureFlagKey } from "@redotech/feature-flags-model/keys";

export const BillingFlagKey = {
  RELEASE_L3_CHARGE_METADATA: featureFlagKey("release-l-3-charge-metadata"), // 19 May 2025 https://app.launchdarkly.com/projects/default/flags/release-l-3-charge-metadata/targeting?env=test&selected-env=test
  RELEASE_LOCAL_CURRENCY_BILLING: featureFlagKey(
    "release-local-currency-billing",
  ), // Bill opted-in merchants in their local currency; off = bills stay USD
  MERCURY_OFFER_BILLING_PAGE: featureFlagKey("mercury-offer-billing-page"), // Show the Mercury partner offer card on the merchant billing page
} as const;
